<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İzin Türü</label>
            <input type="text" class="form-control" v-model="value.Name" placeholder="İzin Türü" />
        </div>
       
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return{
            
        }
    },
    mounted(){
       
    },
    methods:{
    
    },
    computed:{
        
    }
}
</script>

<style>

</style>